<template>
	<div>
		<div style="margin-top: 20px;">
			<el-button type="primary" icon="el-icon-plus" @click="add"
				>添加活动</el-button
			>
		</div>
		<el-tabs
			v-model="status"
			type="border-card"
			style="margin-top: 20px;"
			@tab-click="tabClick"
		>
			<el-tab-pane
				v-for="item in DouyinList"
				:key="item.name"
				:label="item.label"
				:name="item.name"
			>
				<el-table
					:data="List_Data"
					style="width: 100%"
					@row-dblclick="dblclick"
				>
					<el-table-column prop="id" label="Id" width="80"> </el-table-column>
					<el-table-column prop="title" label="活动名称"> </el-table-column>
					<el-table-column prop="first_jump" label="活动类型">
						<template slot-scope="scope">
							<span
								v-text="
									scope.row.first_jump == '1'
										? '优惠'
										: scope.row.first_jump == '2'
										? '支付'
										: '抽奖'
								"
							></span>
						</template>
					</el-table-column>
					<el-table-column prop="room_name" label="所属门店"> </el-table-column>
					<el-table-column prop="start_time" label="开始时间" width="250">
					</el-table-column>
					<el-table-column prop="end_time" label="结束时间" width="250">
					</el-table-column>
					<el-table-column prop="status" label="活动状态" width="100">
						<template slot-scope="scope">
							<el-tag
								:type="
									scope.row.status == 2
										? 'success'
										: scope.row.status == 1
										? 'info'
										: 'danger'
								"
								v-text="
									scope.row.status == 2
										? '进行中'
										: scope.row.status == 1
										? '未开始'
										: '已结束'
								"
							></el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="300">
						<template slot-scope="scope">
							<el-button
								size="small"
								type="primary"
								@click="edit_lottery(scope.row)"
								>修改</el-button
							>
							<el-popconfirm
								title="确定删除这条信息吗？"
								@onConfirm="DouyinList_del(scope.row)"
							>
								<el-button style="margin: 0 5px;" slot="reference" size="small"
									>删除</el-button
								>
							</el-popconfirm>
							<el-button
								size="small"
								type="text"
								@click="Dy_statistics(scope.row)"
								>活动统计</el-button
							>
							<el-button
								size="small"
								type="text"
								@click="download_qrcode_method(scope.row)"
								>下载活动二维码</el-button
							>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					style="float: right;margin-top: 20px;"
					background
					layout="prev, pager, next"
					:total="total"
					@current-change="currentChange"
				>
				</el-pagination>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import time from "@/utils/time";
import store from "@/store/index";
import { download_qrcode, Douyin_del, Douyin_List } from "@/api/Douyin";
export default {
	data() {
		return {
			List_Data: [],
			DouyinList: [
				{
					name: "0",
					label: "全部",
				},
				{
					name: "1",
					label: "未开始",
				},
				{
					name: "2",
					label: "进行中",
				},
				{
					name: "3",
					label: "已结束",
				},
			],
			total: 0,
			page: 1,
			status: "0",
			form: {},
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		//初始化
		init() {
			this.get_Douyin_List_Data();
		},
		//统计
		Dy_statistics(row) {
			this.$router.push({
				path:
					"/apply/newVip/13/market/marketing/client/activity_Douyin/Dy_statistics",
				query: {
					id: row.id,
				},
			});
		},
		//分页
		currentChange(val) {
			this.page = val;
			this.get_Douyin_List_Data();
		},
		//添加活动
		add() {
			this.$router.push({
				path:
					"/apply/newVip/13/market/marketing/client/activity_Douyin/add_Douyin",
				query: {
					key: "add",
				},
			});
		},
		//双击表格某一行
		dblclick(row, column, event) {
			console.log(row, column, event);
		},
		//获取活动列表
		async get_Douyin_List_Data() {
			try {
				const res = await Douyin_List({
					app_id: store.getters.app_id,
					page: this.page,
					limit: 10,
					sn: this.form.sn,
					title: this.form.title,
					room_id: this.form.room_id,
					status: this.status == "0" ? null : this.status,
				});
				if (res.code == 200) {
					this.List_Data = res.data.data;
					this.total = res.data.total;
				}
			} catch (e) {
				console.log(e);
			}
		},
		//删除抖音活动
		async DouyinList_del(row) {
			const res = await Douyin_del({
				app_id: store.getters.app_id,
				id: row.id,
			});
			if (res.code == 200) {
				this.$message.success("删除成功");
				this.get_Douyin_List_Data();
			} else {
				this.$message.error(res.msg);
			}
		},
		//下载抖音活动二维码
		download_qrcode_method(row) {
			try {
				var param =
					"?token=" +
					store.getters.token +
					"&app_id=" +
					store.getters.app_id +
					"&id=" +
					row.id;
				var url1 =
					"https://www.58zltc.com/manage/douyin.activity/download_qrcode" +
					param;
				if (localStorage.getItem("baseStatus") == "test") {
					url1 =
						"https://cs.58zltc.com/manage/douyin.activity/download_qrcode" +
						param;
				}
				window.location.href = url1;
			} catch (e) {
				console.log(e);
			}
		},

		//点击tabs触发
		tabClick(val) {
			this.status = val.name;
			this.get_Douyin_List_Data();
		},
		//点击修改
		async edit_lottery(row) {
			try {
				this.$router.push({
					path:
						"/apply/newVip/13/market/marketing/client/activity_Douyin/add_Douyin",
					query: {
						id: row.id,
						key: "edit",
					},
				});
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>
